// removed by extract-text-webpack-plugin
module.exports = {"bannerLogoContainer":"ATTBannerLogo__bannerLogoContainer"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/ATTBannerLogo/ATTBannerLogo.scss
// module id = 2398
// module chunks = 8